import _useTriggerWorkflowEventMutation from "./__generated__/useTriggerWorkflowEventMutation.graphql";
import { graphql, newId, useMutation } from "@workflows/runtime-web";
import { useViewerTenant } from "@workflows/ui";
import { useTriggerWorkflowEventMutation, useTriggerWorkflowEventMutation$data } from "./__generated__/useTriggerWorkflowEventMutation.graphql";
type WorkflowIdentifier = "de.tigges.dcocom.workflows.createComplaint.v1" | "de.tigges.dcocom.workflows.createWhistleblow.v1" | "de.tigges.dcocom.workflows.createSupplychain.v1";
type EventIdentifier = "createComplaint" | "createWhistleblow" | "createSupplychain";
export interface UseTriggerWorkflowEventConfig {
  onError: (error: Error) => void;
  onCompleted: (data: useTriggerWorkflowEventMutation$data) => void;
  input: {
    payloadJSON: string;
    workflowIdentifier: WorkflowIdentifier;
    eventIdentifier: EventIdentifier;
    matterId?: string;
    code?: string;
  };
}
export function useTriggerWorkflowEvent(): [triggerWorkflowEvent: (props: UseTriggerWorkflowEventConfig) => void, isPending: boolean] {
  const {
    tenantId
  } = useViewerTenant(true);
  const [triggerWorkflowEvent, isPending] = useMutation<useTriggerWorkflowEventMutation>($useTriggerWorkflowEventMutation);
  const handler = (props: UseTriggerWorkflowEventConfig) => {
    const {
      onError,
      onCompleted,
      input: {
        payloadJSON,
        workflowIdentifier,
        eventIdentifier,
        matterId,
        code
      }
    } = props;
    triggerWorkflowEvent({
      variables: {
        input: {
          clientMutationId: newId(),
          eventIdentifier,
          payloadJSON,
          tenantId,
          matterId: matterId || undefined,
          workflowIdentifier,
          code: code || undefined
        }
      },
      onError,
      onCompleted
    });
  };
  return [handler, isPending];
}
const $useTriggerWorkflowEventMutation = (_useTriggerWorkflowEventMutation.hash && _useTriggerWorkflowEventMutation.hash !== "288b3435b7462849b2df685d161a9ee3" && console.error("The definition of 'useTriggerWorkflowEventMutation' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _useTriggerWorkflowEventMutation);